import { createContext } from 'react';

export const initialState = {
  categories: [],
  networking: 0,
  panierOpenState: false,
  panierListState: false,
  selectedProductTobeAdded: null,
  paniers: [],
  profile: JSON.parse(localStorage.getItem('edge_profile') || 'null') || {},
  commercials: [],
  expeditions: [],
  families: [],
};

const ConfigContext = createContext(initialState);

export const { Provider } = ConfigContext;

export default ConfigContext;
